module.exports = __webpack_public_path__ + "static/banner-6d847a7ee978f3a5578e15b26cb5b6b4.png";